import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { Button } from "@/components/ui/button";
import { useGetEvent } from "@/features/events/api/get-event";
import { ManageEventForm } from "@/features/events/components/manage-event.form";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";

function EditEventPage() {
  const { id } = useParams<{ id: string }>();

  const {
    data: event,
    isLoading,
    isError,
    isSuccess,
    error,
  } = useGetEvent(id ?? "");

  if (isLoading) {
    return (
      <>
        <Button variant="ghost" asChild className="mb-6 self-start">
          <Link to="/events/discover">
            <ArrowLeft className="mr-2 size-4" aria-hidden="true" />
            Return to Events
          </Link>
        </Button>
        <OnboardingHeader title="Edit Event" className="mb-6" />

        <LoadingScreen />
      </>
    );
  }

  if (isError || !isSuccess) {
    return (
      <>
        <Button variant="ghost" asChild className="mb-6 self-start">
          <Link to="/events/discover">
            <ArrowLeft className="mr-2 size-4" aria-hidden="true" />
            Return to Events
          </Link>
        </Button>
        <OnboardingHeader title="Edit Event" className="mb-6" />

        <ErrorMessage error={error} />
      </>
    );
  }

  return (
    <div>
      <Button variant="ghost" asChild className="mb-6 self-start">
        <Link to="/events/discover">
          <ArrowLeft className="mr-2 size-4" aria-hidden="true" />
          Return to Events
        </Link>
      </Button>
      <OnboardingHeader title="Edit Event" className="mb-6" />
      <div className="gap-4 space-y-4 md:grid md:grid-cols-12 md:space-y-0">
        <div className="col-span-7 flex flex-col space-y-4">
          <ManageEventForm initialValues={event} />
        </div>
      </div>
    </div>
  );
}

export default EditEventPage;
